// Attention!
// Do not edit directly! The hardcoded values of these tokens are token references
// that get resolved when the .js/d.ts files are being generated from the token JSON files.
export const GLOBAL_BORDER_FOCUS_DARK = '#0989ffff 4px solid';
//# sourceMappingURL=border.dark.generated.js.map